export default __webpack_public_path__ + "src/images/packages/zannier-hotels-omaanda/d2eac01cbecc117253ebb14f0acd28d9-5.jpg";